import { render, staticRenderFns } from "./ScriptLoaderPayPalPlus.vue?vue&type=template&id=d87b16e4&"
import script from "./ScriptLoaderPayPalPlus.vue?vue&type=script&lang=js&"
export * from "./ScriptLoaderPayPalPlus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports